var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center my-3 mx-5"},[_c('strong',[_vm._v("Cargando datos...")]),_c('b-spinner',{staticClass:"ml-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }